module.exports = __webpack_public_path__ + "img/master-card.a599d88c.svg";